import React from "react";
import Card from "@mui/material/Card";
import { CardHeader, Divider, Typography } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import AttachmentList from "../../components/AttachmentList/AttachmentList";
import { getTimeFromNow } from "../../functions/time";

export default function PostingDetail(props) {
  const { item } = props;

  const timeFromNow = getTimeFromNow(item.createdAt);
  const subheader = `${item.author} ${timeFromNow}`;

  return (
    <Card>
      <CardHeader title={item.subject} subheader={subheader} />

      {item.body && (
        <React.Fragment>
          <Divider />
          <CardContent>{renderDescription(item.body)}</CardContent>
        </React.Fragment>
      )}

      {item.attachments && (
        <React.Fragment>
          <Divider />
          <AttachmentList attachments={item.attachments} />
        </React.Fragment>
      )}
    </Card>
  );
}

const renderDescription = (body) => {
  const descriptionArray = body ? body.split(/\n/) : [];
  const descriptionRows = descriptionArray.map((row, index) => {
    return (
      <Typography key={index} style={{ minHeight: "19px" }}>
        {row.split()}
      </Typography>
    );
  });

  return <div>{descriptionRows}</div>;
};
